import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { uomLoader } from "@/screens/WarehouseReceiving/loaders"
import { CheckedInGoodsReceiptDetailsLayout } from "@/screens/WarehouseReceiving/subfeatures/CheckedIn/components"

const searchSchema = z.object({
  showSuccessDialog: z.boolean().optional(),
})

export const Route = createFileRoute("/app/warehouse-receiving/checked-in/$goodsReceiptId/_layout")({
  validateSearch: searchSchema,
  loader: uomLoader,
  component: () => <CheckedInGoodsReceiptDetailsLayout />,
})
